import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
}
export function AccordionItem({
  title,
  children,
  isOpen: defaultOpen = false
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="mb-4 bg-white rounded-2xl shadow-sm border border-brand-pastelpink overflow-hidden" data-id="element-234">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-235">
        <span className="font-semibold text-brand-black pr-4" data-id="element-236">{title}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0 text-brand-pink" data-id="element-237">
          <ChevronDown size={20} data-id="element-238" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-239">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-240">
            <div className="px-6 pb-4 text-gray-600 text-sm leading-relaxed border-t border-brand-babypink pt-4" data-id="element-241">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}